import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"ticket"},"children":[{"tag":"path","attrs":{"id":"fill1","fill":"props.fillColor1","d":"M22 5V8.83682C20.8175 9.39855 20 10.6038 20 12C20 13.3962 20.8175 14.6015 22 15.1632V19L2 19V15.1632C3.18247 14.6015 4 13.3962 4 12C4 10.6038 3.18247 9.39855 2 8.83682V5H22Z"}},{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M22 5V8.83682C20.8175 9.39855 20 10.6038 20 12C20 13.3962 20.8175 14.6015 22 15.1632V19L2 19V15.1632C3.18247 14.6015 4 13.3962 4 12C4 10.6038 3.18247 9.39855 2 8.83682V5H22Z","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M9 10H15M9 14H15","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const Ticket = Vue.extend<IconProps>({
  name: 'TicketIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'ticket',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Ticket;
